import { createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import CloseIcon from 'components/Icons/CloseIcon';
import DownIcon from 'assets/icons/DownIcon';
import RefreshIcon from 'components/Icons/RefreshIcon';
import { useRotateAnimation } from 'components/commons';
import { FC, MouseEventHandler } from 'react';
import ErrorIcon from 'assets/icons/ErrorIcon';

const useStyle = makeStyles(
  () =>
    createStyles({
      root: {
        width: 16,
        height: 16,
        marginLeft: -16,
        color: 'inherit',
        pointerEvents: 'none',
      },
      disableMargin: {
        marginLeft: 'auto',
      },
      clear: {
        width: 12,
        height: 12,
      },
      delete: {
        width: 22,
        height: 22,
      },
    }),
  { name: 'SelectIconComponent' }
);

interface SelectIconProps {
  isLoading?: boolean;
  disableMargin?: boolean;
}

export const SelectIconComponent: FC<SelectIconProps> = ({
  isLoading,
  disableMargin,
}) => {
  const classes = useStyle();
  const rotate = useRotateAnimation();

  if (isLoading) {
    return (
      <RefreshIcon
        className={clsx(classes.root, rotate.complete, {
          [classes.disableMargin]: disableMargin,
        })}
      />
    );
  }

  return (
    <DownIcon
      className={clsx(classes.root, {
        [classes.disableMargin]: disableMargin,
      })}
    />
  );
};

export const selectIcon = (loading?: boolean, disableMargin?: boolean) => {
  return (
    <SelectIconComponent isLoading={loading} disableMargin={disableMargin} />
  );
};

export const ClearIcon: FC = () => {
  const classes = useStyle();
  return <CloseIcon className={classes.clear} />;
};

export const clearIcon = () => <ClearIcon />;

interface DeleteIconProps {
  className?: string;
  onClick?: MouseEventHandler;
}

export const DeleteIcon: FC<DeleteIconProps> = ({
  className = '',
  onClick,
}) => {
  const classes = useStyle();
  return (
    <ErrorIcon
      className={clsx(classes.delete, {
        [className]: className.length > 0,
      })}
      onClick={onClick}
    />
  );
};

export const deleteIcon = () => <DeleteIcon />;

type CheckboxSize = 'small' | 'default';

export const checkboxUnselected = (size: CheckboxSize = 'default') => (
  <svg
    width={size === 'small' ? 18 : 21}
    height={size === 'small' ? 18 : 21}
    viewBox='0 0 21 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect y='0.500122' width='20.049' height='20' rx='4' fill='#C4C4C4' />
  </svg>
);
export const checkboxSelected = (size: CheckboxSize = 'default') => (
  <svg
    width={size === 'small' ? 18 : 21}
    height={size === 'small' ? 18 : 21}
    viewBox='0 0 21 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect y='0.500122' width='20.049' height='20' rx='4' fill='#3FA110' />
  </svg>
);

export const checkboxSelectedEditEscola = (size: CheckboxSize = 'default') => (
  <svg
    width={size === 'small' ? 18 : 21}
    height={size === 'small' ? 18 : 21}
    viewBox='0 0 21 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect y='0.500122' width='20.049' height='20' rx='4' fill='#9fdc8c' />
  </svg>
);
